var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"break section-block"},[_c('div',{staticClass:"section-block__title"},[_vm._v("Место работы")]),(_vm.data && _vm.data.jobPlace)?_c('div',{staticClass:"row-box"},_vm._l((_vm.data.jobPlace),function(value,index){return _c('WrapperField',{key:value + index + Math.random(),attrs:{"data":_vm.createDataField({
        fieldName: index, 
        fieldValue: value, 
        fieldGroup: 'jobPlace',
        fieldGroupEdit: _vm.data.jobPlace.orgName ? 'organization' : false,
      })}})}),1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }